import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { WebsocketService } from './websocket.service';

export type ChangeStates = "INIT" | "LOGIN_WAIT" | "AUTOLOGIN_EXECUTION" | "LOGGED" | "ERROR" | "LOGOUT";

@Injectable({
    providedIn: 'root'
})
export class AuthStateService implements OnDestroy {
    private _token?: string;
    changes$ = new BehaviorSubject<ChangeStates>('INIT');
    loginData: any = {};
    destroy$ = new Subject<void>();


    constructor(
        private router: Router,
        private ws: WebsocketService
    ) { }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    get token(): string | undefined {
        return this._token;
    }

    set token(value: string | undefined) {
        this._token = value;
    }

    get isLogged(): boolean {
        return this._token !== undefined;
    }

    logout(goToLogin: boolean = true, url?: string) {
        this._token = undefined;
        localStorage.removeItem('auth');
        this.changes$.next("LOGOUT");
        this.ws.disconnectWs()
        if (goToLogin) {
            this.router.navigate(['/login']);
            sessionStorage.setItem('returnUrl', url ?? '');
        }
    }
}
